<template>
  <div class="catalog-view" :class="{ 'sidebar-collapsed': leftSidebarCollapsed }" v-if="readPermission">
    <div class="left-sidebar">
      <div class="toggle-button d-flex justify-content-center align-items-center" @click="leftSidebarCollapsed = !leftSidebarCollapsed">
        <i class="fas fa-caret-right" v-if="leftSidebarCollapsed"></i>
        <i class="fas fa-caret-left" v-else></i>
      </div>
      <div class="catalog-name">
        <i class="fad fa-key"></i>
        <span>Permisos</span>
      </div>

      <!-- FILTERS AND VIEWS -->
      <div class="filters" v-if="currentAction === crudActions.READ">
        <div class="filter-items">

          <div class="filter-item" v-if="canFilterByDomain">
            <label>Dominio</label>
            <b-form-group style="position: relative">
              <b-form-input
                type="text"
                class="shadow-none"
                placeholder="Seleccione el dominio"
                v-model.trim="searchDomain"
                :maxlength="255"
                autocomplete="off"
                @click="showDomainSelection(true)"
                @focus="showDomainSelection(true)"
                @blur="showDomainSelection(false)">
              </b-form-input>
              <div class="dropdown-input-selection-list" v-if="domainSelectionOpen" style="position: absolute; top: 40px; z-indez: 2">
                <table class="table">
                  <tbody>
                    <tr v-for="it in domains" :key="it.id" @click="selectDomain(it)" v-show="isMatchDomain(it)">
                      <td>{{ it.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-form-group>
          </div>

          <div class="filter-item">
          <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100">
            <b-dropdown-group id="dropdown-group-fields" header="Filtro sobre campo:">
              <b-dropdown-item-button
                v-for="option in fieldOptionsAvailable"
                :key="option"
                @click="searchByTag(option)"
              >
              {{option}}
              </b-dropdown-item-button>
            </b-dropdown-group>
            <template #button-content>
              <i class="fad fa-tags"></i> {{ currentColumnOption || filters.defaultSearchOptions }}
            </template>
          </b-dropdown>
          <b-input-group aria-controls="input-filter-by">
            <input
              size="sm"
              v-model="searchBy"
              placeholder="Agregar filtro ..."
              class="form-control"
              @keyup.enter="createTag">
            <b-input-group-append style="z-index: 1">
              <b-button size="sm" @click="createTag()" variant="outline-secondary"><i class="fal fa-plus"></i></b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-tag
            id="filter-tags"
            v-for="option in searchOptionsCreated"
            :key="option"
            @remove="removeTag(option)"
            add-on-change
            no-outer-focus>
            {{ option }}
          </b-form-tag>
          </div>

          <div class="filter-item">
            <div>
              <b-form-group label="Versión" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="checkbox-version"
                  v-model="filters.versionSelected"
                  :options="filters.versionFilters"
                  :aria-describedby="ariaDescribedby"
                  name="checkbox-version"
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group label="Efecto" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="checkbox-effect"
                  v-model="filters.effectSelected"
                  :options="effectOptionsSorted"
                  :aria-describedby="ariaDescribedby"
                  name="cehckbox-efect"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group label="Recurso" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="checkbox-resource"
                  class="checkbox-filters"
                  v-model="filters.resourceSelected"
                  :options="resourceOptionsSorted"
                  :aria-describedby="ariaDescribedby"
                  name="checkbox-resource"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>

        <b-row class="main-actions">
          <b-overlay
            class="main-actions__overlay"
            spinner-type="grow"
            spinner-small
            :show="loadingData">
            <b-col cols="6">
              <b-button block size="sm" class="shadow-sm" @click="cleanFilter" :disabled="loadingData">Limpiar</b-button>
            </b-col>
            <b-col cols="6">
              <b-button variant="primary" block size="sm" class="shadow-sm" @click="filterItems" :disabled="loadingData">Buscar</b-button>
            </b-col>
          </b-overlay>
        </b-row>
      </div>

      <div class="short-list" v-if="currentAction !== crudActions.READ">
        <h5>Registros:</h5>
        <b-list-group>
          <b-list-group-item
            class="text-truncate"
            v-for="item in filteredItems"
            :title="item.id + ' - ' + item.name"
            :key="item.id"
            :active="selectedItem == item"
            @click="selectItem(item)">
            {{ item.name }}
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>

    <div class="right-side">
      <div class="grid">
        <!-- TOP BUTTONS BAR -->
        <div class="top-tool-bar">
          <div class="action d-none d-lg-block" @click="newItem" v-if="createPermission"><i class="fal fa-file-plus"></i> Nuevo</div>
          <div class="action d-none d-lg-block" @click="queryItem" :class="{ disabled: !selectedItem.id }"><i class="fal fa-print-search"></i> Detalle</div>
          <div class="action d-none d-lg-block" @click="updateItem" v-if="updatePermission" :class="{ disabled: !selectedItem.id }"><i class="fal fa-file-edit"></i> Modificar</div>
          <div class="action d-none d-lg-block" @click="deleteItem" v-if="deletePermission" :class="{ disabled: !selectedItem.id }"><i class="fal fa-trash-alt"></i> Eliminar</div>
          <div class="action d-none d-lg-block" title="Descargar registros" @click="printCsv"><i class="fal fa-file-spreadsheet"></i> Exportar</div>
          <div class="action d-none d-lg-block" title="Refrescar tabla para obtener las últimas actualizaciones" @click="updateData"><i class="fal fa-sync"></i> Refrescar</div>
          <div class="actions-collapsed d-lg-none">
            <b-dropdown class="shadow-sm" text="Acciones">
              <b-dropdown-item @click="newItem" v-if="createPermission"><i class="fal fa-file-plus"></i> Nuevo</b-dropdown-item>
              <b-dropdown-item @click="queryItem" v-if="selectedItem.id"><i class="fal fa-print-search"></i> Detalle</b-dropdown-item>
              <b-dropdown-item @click="updateItem" v-if="updatePermission && selectedItem.id"><i class="fal fa-file-edit"></i> Modificar</b-dropdown-item>
              <b-dropdown-item @click="deleteItem" v-if="deletePermission && selectedItem.id"><i class="fal fa-trash-alt"></i> Eliminar</b-dropdown-item>
              <b-dropdown-item @click="printCsv"><i class="fal fa-file-spreadsheet"></i> Exportar</b-dropdown-item>
              <b-dropdown-item @click="updateData"><i class="fal fa-sync"></i> Refrescar</b-dropdown-item>
            </b-dropdown>
          </div>
          <TopToolBarPaginator :key="paginatorKey" :totalItems="filteredItems.length" :pageSize="PAGE_SIZE_VISIBLE_ITEMS" @pageChange="onPageChange" v-b-tooltip.hover.left="'Total de registros: ' + filteredItems.length"/>
        </div>

        <!-- DATA TABLE -->
        <div class="table-container">
          <table class="data-table table table-hover">
            <thead>
              <tr>
                <template v-for="(col, index) in permissionColumns">
                  <th :key="index">
                    <div>
                      {{ col.name }}
                    </div>

                    <div v-if="col.sort" class="sort" @click="sortItems(col)">
                      <i class="fad fa-sort"></i>
                    </div>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredItems" :key="item.id" @click="selectItem(item)" @dblclick="selectItemAndShowDetail(item)" :class="{ 'selected': isItemSelected(item) }" v-show="isRowVisibleInPage(index)">
                <template v-for="(col, index) in permissionColumns">
                  <template v-if="index === 0">
                    <th :key="index">
                      {{ item[col.key] }}
                    </th>
                  </template>
                  <template v-else>
                    <td :key="index">
                      <div :title="item[col.key] && item[col.key].length > 40 ? item[col.key] : ''">{{ item[col.key] }}</div>
                    </td>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- CONSULTA DE DETALLE -->
      <transition name="fade-in-right">
        <div class="detail" v-if="currentAction === crudActions.READ_DETAIL">
          <AdminPermissionForm :domainId="domainIdSelected" :id="selectedItem.id" :key="selectedItem.id" :readOnly="true" :title="'Permiso ' + selectedItem.name" @close="onCancelForm" @saved="onItemSaved" @edit-mode="changeToEditMode" @delete-item="deleteItem"/>
        </div>
      </transition>

      <!-- NUEVO REGISTRO -->
      <transition name="fade-in-right">
        <div class="detail" v-if="currentAction === crudActions.CREATE">
          <AdminPermissionForm :domainId="domainIdSelected" :id="selectedItem.id" :key="selectedItem.id" title="Nuevo Permiso" @close="currentAction = crudActions.READ" @saved="onItemSaved" />
        </div>
      </transition>

      <!-- ACTUALIZACIÓN -->
      <transition name="fade-in-right">
        <div class="detail" v-if="currentAction === crudActions.UPDATE">
          <AdminPermissionForm :domainId="domainIdSelected" :id="selectedItem.id" :key="selectedItem.id" :title="'Modificando ' + selectedItem.name" @close="currentAction = crudActions.READ" @saved="onItemSaved" />
        </div>
      </transition>

      <!-- LOADING MASK -->
      <div class="loading-mask" v-show="loadingData">
        <i class="far fa-spinner-third fa-spin"></i>
      </div>
    </div>

    <a class="hidden-csv-download-link" ref="csvDownload"></a>
  </div>
  <div v-else>
    <div id="not-sufficent-permissions" class="page-wrap d-flex flex-row align-items-center">
        <div class="container">
          <div class="row justify-content-center">
              <div class="col-md-12 text-center">
                  <span class="display-1 d-block">403</span>
                  <div class="mb-4 lead">Lo sentimos, no tienes permisos suficientes para consultar estos registros.</div>
              </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import AdminPermissionForm from '@/components/admin/AdminPermissionForm.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import TopToolBarPaginator from '@/components/generic/TopToolBarPaginator.vue'
import catalogsService from '@/services/CatalogsService'
import { CrudActions, CatalogGridItemColumn, PermissionCatalogFilters, PermissionCatalogGridItem, Permission, BasicEntity, DomainCatalogFilters, Domain } from '@/types/Catalogs'
import { PageRequest } from '@/types/Support'
import userInfoStore from '@/store/userInfo'
import { PermissionNames } from '@/types/Auth'
import DateFormat from '@/services/DateFormat'
import LogService, { ToString } from '@/services/support/LogService'

@Component({
  components: {
    AdminPermissionForm,
    MessageError,
    TopToolBarPaginator
  }
})
export default class AdminPermissions extends Vue {
  PAGE_SIZE = 500
  PAGE_SIZE_VISIBLE_ITEMS = 50
  itemsVisibleRange = [0, this.PAGE_SIZE_VISIBLE_ITEMS]
  paginatorKey = 0
  crudActions = CrudActions
  currentAction = CrudActions.READ
  loadingData = false
  leftSidebarCollapsed = false
  // Grid columns definition
  currentPage = 1
  perPage = 20
  permissionColumns: CatalogGridItemColumn[] = [
    CatalogGridItemColumn.def('id', 'ID', true),
    CatalogGridItemColumn.def('name', 'Nombre', true),
    CatalogGridItemColumn.def('domain', 'Dominio', true),
    CatalogGridItemColumn.def('resource', 'Recurso', true),
    CatalogGridItemColumn.def('effect', 'Efecto', true),
    CatalogGridItemColumn.def('label', 'Etiqueta', true),
    CatalogGridItemColumn.def('version', 'Versión', true),
    CatalogGridItemColumn.def('description', 'Descripción', true),
    CatalogGridItemColumn.def('creation', 'Fecha de creación', true),
    CatalogGridItemColumn.def('update', 'Fecha de actualización', true)
  ]
  items: PermissionCatalogGridItem[] = []
  filteredItems: PermissionCatalogGridItem[] = []
  filters = new PermissionCatalogFilters()
  /** Filters */
  totalItems: number = 0
  selectedItem = new PermissionCatalogGridItem()
  columnOptions: string[] = []
  currentColumnOption = ''
  searchOptionsSelected: string[] = []
  searchOptionsCreated: string[] = []
  searchNames: string[] = []
  searchDomains: string[] = []
  searchResources: string[] = []
  searchEffects: string[] = []
  searchLabels: string[] = []
  searchBy = ''

  created () {
    this.updateData()
    this.columnOptions = this.filters.columnOptions
    this.currentColumnOption = this.filters.defaultSearchOptions
    if (this.canFilterByDomain) {
      this.loadDomains(new PageRequest<DomainCatalogFilters>(this.PAGE_SIZE))
    }
  }

  /* Sort */

  get effectOptionsSorted () {
    return this.filters.effectFilters.sort(this.sortFilters)
  }

  get resourceOptionsSorted () {
    return this.filters.resourceFilters.sort(this.sortFilters)
  }

  sortFilters (a: {text: string, value: string}, b: {text: string, value: string}) {
    if (a.text < b.text) {
      return -1
    } else if (a.text > b.text) {
      return 1
    }
    return 0
  }

  /* User permissions */

  /**
   * Checks if user has 'permission' permission
   * @param permission name to check
   */
  hasPermission (permision: string) {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === permision)
  }

  /**
   * Check if user has 'permissions:create' permission
   */
  get readPermission () {
    return this.hasPermission(PermissionNames.PERMISSIONS_READ)
  }

  /**
   * Check if user has 'permissions:create' permission
   */
  get createPermission () {
    return this.hasPermission(PermissionNames.PERMISSIONS_CREATE)
  }

  /**
   * Check if user has 'permissions:update' permission
   */
  get updatePermission () {
    return this.hasPermission(PermissionNames.PERMISSIONS_UPDATE)
  }

  /**
   * Check if user has 'permissions:delete' permission
   */
  get deletePermission () {
    return this.hasPermission(PermissionNames.PERMISSIONS_DELETE)
  }

  /**
   * Checks if the user can view domain filter, for this
   * the user must belongs to root domain and has domains read permission.
   */
  get canFilterByDomain () {
    return userInfoStore.inRootDomain() && this.hasPermission(PermissionNames.DOMAINS_READ)
  }

  /* Load data */

  /**
   * Clear and update all permission records
   */
  async updateData () {
    if (this.loadingData) return
    this.loadingData = true
    this.items = []
    const pageRequest = new PageRequest<PermissionCatalogFilters>(this.PAGE_SIZE)
    pageRequest.filters = this.filters
    await this.loadPage(pageRequest)
  }

  /**
   * Get all permission records and assign them in 'items' variable
   * @param pageRequest - configurations to request
   */
  async loadPage (pageRequest: PageRequest<any>) {
    await catalogsService.getPermissions(pageRequest).then(response => {
      this.items.push(...response.results.map((it: Permission): PermissionCatalogGridItem => {
        return this.fillGridItem(it, new PermissionCatalogGridItem())
      }))
      if (this.items.length < response.total) {
        pageRequest.page++
        this.loadPage(pageRequest)
      } else {
        this.loadingData = false
        this.filteredItems = this.items
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de permisos: ${ToString(error.response ?? error)}`)
      this.loadingData = false
    })
  }

  /**
   * Gets all domains records and assing them in 'domains' variable
   * @param pageRequest - request configurations
   */
  async loadDomains (pageRequest: PageRequest<any>) {
    this.loadingDomains = true
    await catalogsService.getDomains(pageRequest).then((response) => {
      this.domains.push(...response.results.map((it: Domain) => {
        return { id: it.id, name: it.name } as BasicEntity
      }))
      if (this.domains.length < response.total) {
        pageRequest.page++
        this.loadDomains(pageRequest)
      }
    }).finally(() => {
      this.loadingDomains = false
      this.selectDefaultDomain()
    })
  }

  /* Grid and action events */

  /**
   * Select the current item on double clic.
   * @param item - row selected on table
   */
  selectItemAndShowDetail (item: any) {
    this.currentAction = CrudActions.READ_DETAIL
    this.selectItem(item)
  }

  /**
   * Select the current item and assign it in 'selectedItem' variable.
   * @param item - row selected on table
   */
  selectItem (item: any) {
    switch (this.currentAction) {
      case CrudActions.READ:
      case CrudActions.READ_DETAIL:
      case CrudActions.UPDATE:
      case CrudActions.DELETE:
        this.selectedItem = item
        break
      case CrudActions.CREATE:
        this.selectedItem = this.updatePermission ? item : this.selectedItem
        this.currentAction = CrudActions.UPDATE
        break
    }
  }

  /**
   * Check if 'item' is the current item selected
   * @param item - row table
   */
  isItemSelected (item: any) {
    return this.selectedItem === item
  }

  /** Clear the current selected item */
  cleanItemSelected () {
    this.selectedItem = new PermissionCatalogGridItem()
  }

  /**
   * This triggers a form view transition event to read permission
   */
  queryItem () {
    if (this.selectedItem.id) {
      this.currentAction = CrudActions.READ_DETAIL
    }
  }

  /**
   * This triggers a form view transition event to create permission
   */
  newItem () {
    this.selectedItem = new PermissionCatalogGridItem()
    this.currentAction = CrudActions.CREATE
  }

  /**
   * This triggers a form view transition event to update permission
   */
  updateItem () {
    if (this.selectedItem.id) {
      this.currentAction = CrudActions.UPDATE
    }
  }

  /**
   * Delete the current permission selected after a confirmation message.
   */
  deleteItem () {
    if (this.selectedItem.id) {
      let messageConfirmation = `Esta por eliminar el registro:\
        "${this.selectedItem.id} - ${this.selectedItem.name}".\
        Esta acción es irreversible y se perderá permanentemente dicho registro.\
        ¿Estás seguro de continuar?`
      this.$bvModal.msgBoxConfirm(messageConfirmation, {
        title: 'Eliminando permiso',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Confirmar',
        cancelVariant: 'outline-secondary',
        cancelTitle: 'Cancelar',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false
      }).then(value => {
        if (value) {
          catalogsService.deletePermissionById(this.selectedItem.id).then((response) => {
            this.$bvToast.toast(`El permiso ${this.selectedItem.id} se ha eliminado correctamente`, {
              title: 'Eliminación finalizada',
              variant: 'success',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 3000
            })
          }).catch((error) => {
            let messageValues = {
              title: 'Error al eliminar el permiso',
              message: '',
              delay: 10000,
              error: error
            }
            let errorComponent = new MessageError({ propsData: messageValues })
            errorComponent.displayMessage()
          }).finally(() => {
            this.updateData()
            this.currentAction = CrudActions.READ
          })
        }
      })
    }
  }

  /**
   * Create a PermissionCatagolGridItem with base on Permission
   * @param origin - to obtains values
   * @param target - PermissionCatalogGridItem to fill with origin object values
   */
  fillGridItem (origin: Permission, target: PermissionCatalogGridItem) {
    target.id = origin.id
    target.name = origin.name
    target.domain = origin.domain
    target.resource = origin.resource
    target.effect = origin.effect
    target.label = origin.label
    target.version = origin.version
    target.description = origin.description
    target.creation = origin.creationDate ? new DateFormat(origin.creationDate).toDateString() : '- - / - - / - - - -'
    target.update = origin.updateDate ? new DateFormat(origin.updateDate).toDateString() : '- - / - - / - - - -'
    return target
  }

  /**
   * Switch to edit mode
   */
  changeToEditMode () {
    this.currentAction = CrudActions.UPDATE
  }

  /* Filter and sorting data */

  /** Calculates visible index range for pagination */
  onPageChange (page: number) {
    this.itemsVisibleRange = [(page - 1) * this.PAGE_SIZE_VISIBLE_ITEMS, (page - 1) * this.PAGE_SIZE_VISIBLE_ITEMS + this.PAGE_SIZE_VISIBLE_ITEMS]
    this.cleanItemSelected()
  }

  /** Reset index range pagination and clear current selected item */
  resetPaginator () {
    this.itemsVisibleRange = [0, this.PAGE_SIZE_VISIBLE_ITEMS]
    this.paginatorKey = new Date().getTime()
    this.cleanItemSelected()
  }

  /**
   * Clear current filter configurations
   */
  cleanFilter () {
    this.filters = new PermissionCatalogFilters()
    this.filteredItems = this.items
    this.searchOptionsSelected = []
    this.searchOptionsCreated = []
    this.searchNames = []
    this.searchDomains = []
    this.searchResources = []
    this.searchEffects = []
    this.searchLabels = []
    this.searchBy = ''
  }

  /**
   * Apply all filters configurations
   */
  async filterItems () {
    this.loadingData = true
    this.resetPaginator()
    if (this.filters.domain !== this.domainIdSelected) {
      this.filters.domain = this.domainIdSelected
      await this.updateData()
    }
    this.applyAllFilters()
    this.loadingData = false
  }

  /** Check if the index of a row is within the visible range  */
  isRowVisibleInPage (rowIndex: number) {
    return rowIndex >= this.itemsVisibleRange[0] && rowIndex < this.itemsVisibleRange[1]
  }

  /**
   * Returns the current number of filtered items
   */
  get countTotalItems () {
    return this.filteredItems.length
  }

  /**
   * Sort current filtered items with base a specific column
   * @param col - column to filter with
   */
  sortItems (col: CatalogGridItemColumn) {
    catalogsService.sortItems(this.filteredItems, col)
  }

  /**
   * Assign column to create filter tags
   * @param tag - field available option clicled
   */
  searchByTag (tag: string) {
    this.currentColumnOption = tag
  }

  /**
   * Create a new tag with base on current culumn to filter
   * and search value introduced, it is pushed on 'searchOptionsCreated'
   */
  createTag () {
    let newTag = this.currentColumnOption + ':' + this.searchBy
    if (this.searchBy && !this.searchOptionsCreated.includes(newTag)) {
      if (!this.searchOptionsSelected.includes(this.currentColumnOption)) {
        this.searchOptionsSelected.push(this.currentColumnOption)
      }
      this.searchOptionsCreated.push(newTag)
      switch (this.currentColumnOption) {
        case 'Name':
          this.searchNames.push(this.searchBy)
          break
        case 'Domain':
          this.searchDomains.push(this.searchBy)
          break
        case 'Resource':
          this.searchResources.push(this.searchBy)
          break
        case 'Effect':
          this.searchEffects.push(this.searchBy)
          break
        case 'Label':
          this.searchLabels.push(this.searchBy)
          break
      }
      this.searchBy = ''
    }
  }

  /**
   * Remove tag from 'searchOptionsCreated' array,
   * that is considered to apply filters
   */
  removeTag (tag: string) {
    let field = tag.split(':')[0]
    let value = tag.split(':')[1]
    this.searchOptionsCreated.splice(this.searchOptionsCreated.indexOf(tag), 1)
    switch (field) {
      case 'Name':
        this.searchNames.splice(this.searchNames.indexOf(value), 1)
        this.deleteFromSelectedOptions(field, this.searchNames.length <= 0)
        break
      case 'Domain':
        this.searchDomains.splice(this.searchDomains.indexOf(value), 1)
        this.deleteFromSelectedOptions(field, this.searchDomains.length <= 0)
        break
      case 'Resource':
        this.searchResources.splice(this.searchResources.indexOf(value), 1)
        this.deleteFromSelectedOptions(field, this.searchResources.length <= 0)
        break
      case 'Effect':
        this.searchEffects.splice(this.searchEffects.indexOf(value), 1)
        this.deleteFromSelectedOptions(field, this.searchEffects.length <= 0)
        break
      case 'Label':
        this.searchLabels.splice(this.searchLabels.indexOf(value), 1)
        this.deleteFromSelectedOptions(field, this.searchLabels.length <= 0)
        break
    }
  }

  /**
   * Delete a field value from 'searchOptionsSelected' array
   * if 'searchOptionsCreated' does not contains a value like 'field:_' or notValues
   * @param field - value to eliminate from 'searchOptionsSelected'
   * @param notValues - indicates that option must eliminated cause has not existences
   */
  deleteFromSelectedOptions (field: string, notValues: boolean) {
    let exitsFilter = false
    this.searchOptionsCreated.forEach(filter => {
      if (filter.split(':')[0] === field) {
        exitsFilter = true
      }
    })
    if (!exitsFilter || notValues) {
      this.searchOptionsSelected.splice(this.searchOptionsSelected.indexOf(field), 1)
    }
  }

  /**
   * Apply all filters created on 'filteredItems'
   */
  applyAllFilters () {
    let nameExpressions: RegExp[] = []
    let domainExpressions: RegExp[] = []
    let resourceExpressions: RegExp[] = []
    let effectExpressions: RegExp[] = []
    let labelExpressions: RegExp[] = []
    this.filteredItems = this.items
    if (this.searchNames.length > 0) {
      nameExpressions = this.createRegularExpressions(this.searchNames)
      this.filteredItems = this.filteredItems.filter(it => this.applyFilters('name', it, nameExpressions))
    }
    if (this.searchDomains.length > 0) {
      domainExpressions = this.createRegularExpressions(this.searchDomains)
      this.filteredItems = this.filteredItems.filter(it => this.applyFilters('domain', it, domainExpressions))
    }
    if (this.searchResources.length > 0) {
      resourceExpressions = this.createRegularExpressions(this.searchResources)
      this.filteredItems = this.filteredItems.filter(it => this.applyFilters('resource', it, resourceExpressions))
    }
    if (this.searchEffects.length > 0) {
      effectExpressions = this.createRegularExpressions(this.searchEffects)
      this.filteredItems = this.filteredItems.filter(it => this.applyFilters('effect', it, effectExpressions))
    }
    if (this.searchLabels.length > 0) {
      labelExpressions = this.createRegularExpressions(this.searchLabels)
      this.filteredItems = this.filteredItems.filter(it => this.applyFilters('label', it, labelExpressions))
    }
    // Basic filters
    if (this.filters.versionSelected.length > 0) {
      this.filteredItems = this.filteredItems.filter(it => this.filters.versionSelected.includes(it.version))
    }
    if (this.filters.effectSelected.length > 0) {
      this.filteredItems = this.filteredItems.filter(it => this.filters.effectSelected.includes(it.effect))
    }
    if (this.filters.resourceSelected.length > 0) {
      this.filteredItems = this.filteredItems.filter(it => this.filters.resourceSelected.includes(it.resource))
    }
  }

  /**
   * Create a regular expressions with base on values string array
   * @param values - strings
   * @returns regular expression array
   */
  createRegularExpressions (values: string[]) {
    let expressions: RegExp[] = []
    values.forEach((val) => {
      expressions.push(new RegExp(val, 'i'))
    })
    return expressions
  }

  /**
   * Apply all regular expressions to a permission grid item
   * over a specific field
   * @param field - field to apply expressions over
   * @param permission - permissions to check expressions
   * @param expressions - all reg exp that applies
   * @returns true if some expression passes on field, false otherwie
   */
  applyFilters (field: string, permission: PermissionCatalogGridItem, expressions: RegExp[]) {
    let apply = false
    expressions.forEach(expression => {
      if (field === 'name' && expression.test(permission.name)) {
        apply = true
      }
      if (field === 'domain' && expression.test(permission.domain.toString())) {
        apply = true
      }
      if (field === 'resource' && expression.test(permission.resource)) {
        apply = true
      }
      if (field === 'effect' && expression.test(permission.effect)) {
        apply = true
      }
      if (field === 'label' && expression.test(permission.label)) {
        apply = true
      }
    })
    return apply
  }

  /**
   * Returns distinct fields to 'currentColumnOption'
   */
  get fieldOptionsAvailable () {
    return this.filters.columnOptions.filter((tag) =>
      (tag !== this.currentColumnOption))
  }

  /* Domain selector */

  domainSelectionOpen = false
  domainIdSelected = -1
  domainSelected: any = {}
  domainSelectedBackup: any = {}
  searchDomain = ''
  domains: BasicEntity[] = []
  loadingDomains = false

  /**
   * Active domainSelectionOpen flag to display the dropdown domain list
   * and updates the searchDomain and domainSelected values when the dropdown is close
   * @param isOpen flag
   */
  showDomainSelection (isOpen: boolean) {
    if (isOpen) {
      this.searchDomain = ''
      this.domainSelected = {}
      this.domainSelectionOpen = true
    } else {
      setTimeout(() => {
        this.domainSelectionOpen = false
        if (this.domainSelectedBackup.name && this.domainSelectedBackup.id !== this.domainSelected.id) {
          this.searchDomain = this.domainSelectedBackup.name
          this.domainSelected = this.domainSelectedBackup
        }
      }, 200)
    }
  }

  /**
   * Validates if a domain name matches with the current searchDomain value
   * @param domain entity to check its name
   */
  isMatchDomain (domain: BasicEntity) {
    if (!this.searchDomain) return true
    const regexSearch = new RegExp(this.searchDomain, 'i')
    return regexSearch.test(domain.name)
  }

  /**
   * Updates domains variables based on 'domain' selected
   * @param domain selected
   */
  selectDomain (domain: BasicEntity) {
    this.domainSelected = domain
    this.domainSelectedBackup = domain
    this.searchDomain = domain.name
    this.domainIdSelected = domain.id
  }

  /**
   * Sets the current user domain as default domain selected
   */
  selectDefaultDomain () {
    this.filters.domain = userInfoStore.userInfo.domain.id
    this.domainIdSelected = userInfoStore.userInfo.domain.id
    const domain = this.domains.find(it => it.id === this.domainIdSelected)
    if (domain) this.selectDomain(domain)
  }

  /* Form */

  onCancelForm () {
    this.currentAction = CrudActions.READ
  }

  onItemSaved (item: Permission) {
    if (!this.selectedItem.id) {
      this.selectedItem = new PermissionCatalogGridItem()
      this.selectedItem.id = item.id
      this.items.unshift(this.selectedItem)
    }
    this.fillGridItem(item, this.selectedItem)
    this.currentAction = CrudActions.READ
  }

  /* Export data */

  printCsv () {
    let csv = ''
      .concat('ID').concat(',')
      .concat('NAME').concat(',')
      .concat('DOMAIN').concat(',')
      .concat('RESOURCE').concat(',')
      .concat('EFFECT').concat(',')
      .concat('LABEL').concat(',')
      .concat('VERSION').concat(',')
      .concat('DESCRIPTION').concat(',')
      .concat('CREACIÓN').concat(',')
      .concat('ACTUALIZACIÓN').concat('\n')

    for (let it of this.filteredItems) {
      csv += ''
        .concat(it.id.toString()).concat(',')
        .concat(it.name).concat(',')
        .concat(it.domain.toString()).concat(',')
        .concat(it.resource).concat(',')
        .concat(it.effect).concat(',')
        .concat(it.label).concat(',')
        .concat(it.version.toString()).concat(',')
        .concat(it.description).concat(',')
        .concat(it.creation).concat(',')
        .concat(it.update).concat('\n')
    }

    let element = this.$refs.csvDownload as any
    element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
    element.target = '_blank'
    element.download = `Permissions.csv`
    element.click()
  }
}
</script>

<style lang="css" scoped>
#not-sufficent-permissions {
    min-height: 100vh;
}
::v-deep #checkbox-resource.checkbox-filters > div.custom-checkbox.custom-control  {
  z-index: 0;
}
</style>
